import { Button } from "@twioku/common_components";
import { Controller } from "react-hook-form";
import { useStoryPost } from "../features/story/hooks/useStoryPost";
import { type FC } from "react";

export const PostStoryPage: FC = () => {
    const { control, onSubmit, isSubmitting, errors } = useStoryPost();

    return (
        <div className="mx-4 pb-32">
            <h1 className="mb-3 mt-5 text-left text-md">
                ツイオクをつうじて感じた、あなたのツイオクストーリーをぜひみなさんにお聞かせください。
            </h1>
            <p className="mb-8 text-sm text-gray-600">
                ※共有いただいたストーリーは
                <span className="underline">みんなのツイオクストーリー</span>
                に掲載され、インターネット上でどなたでも御覧いただけるようになります。
            </p>
            <hr />

            <div className="mt-6 bg-white p-4">
                <Controller
                    name="title"
                    control={control}
                    render={({ field }) => (
                        <>
                            <input
                                {...field}
                                type="text"
                                placeholder="タイトル"
                                className="w-full text-2xl font-medium text-gray-500 placeholder-gray-400 outline-none mb-3"
                                maxLength={100}
                                disabled={isSubmitting}
                            />
                        </>
                    )}
                />
                <Controller
                    name="body"
                    control={control}
                    render={({ field }) => (
                        <>
                            <textarea
                                {...field}
                                placeholder="ツイオクをつうじて得た感動を共有してみませんか？"
                                className="w-full h-72 text-gray-500 placeholder-gray-400 outline-none resize-none"
                                maxLength={2000}
                                disabled={isSubmitting}
                            />
                        </>
                    )}
                />
            </div>
            <div className="fixed bottom-0 left-0 right-0 bg-white px-4 py-4">
                <div className="mx-auto max-w-2xl">
                    <div className="flex justify-end">
                        <Controller
                            name="handleName"
                            control={control}
                            render={({ field }) => (
                                <>
                                    <input
                                        {...field}
                                        type="text"
                                        placeholder="ハンドルネーム"
                                        className="mb-3 w-2/5 text-md font-medium text-gray-500 placeholder-gray-400 outline-none"
                                        maxLength={100}
                                        disabled={isSubmitting}
                                    />
                                </>
                            )}
                        />
                    </div>
                </div>
                <div className="mx-auto max-w-2xl">
                    {(errors.body || errors.handleName) && (
                        <p className="text-red-500 text-sm mt-2">
                            {errors.body?.message || errors.handleName?.message}
                        </p>
                    )}
                    <Button
                        onClick={onSubmit}
                        loading={isSubmitting}
                        className="mb-8 mt-2 w-full"
                    >
                        投稿する
                    </Button>
                </div>
            </div>
        </div>
    );
};
